import { setSeason } from 'seasons';

export const processSeason = ({ dispatch, rawSeason, seasonActivityType, cropId }) => {
  dispatch(setSeason({ rawSeason, seasonActivityType, cropId }));
  return Promise.resolve(rawSeason);
};
